import { Box, Flex, Input, Spinner } from "@chakra-ui/react";
import { DroppableBox } from "components/containers/InspectionFormat/containers/LayoutFrameBuilder";
import { SOURCE } from "components/containers/InspectionFormat/Content/SettingPinLayoutFrame/context/pinLayoutFrameReducer";
import TyphographyIcon from "components/icon/TyphographyIcon";
import { memo } from "react";
import FieldPreviewWrapper from "../../../components/FieldPreviewWrapper";
import { useInputValue } from "../../../hooks/useInputValue";
import { FieldPreviewProps } from "../../types";

interface PreFilledPreviewerProps extends FieldPreviewProps<string> {}

const PreFilledPreviewer: React.FC<PreFilledPreviewerProps> = ({
  item,
  value,
  isReadOnly,
  isLoading,
  isDraggable,
  index,
  allItemResultCount,
  prevItemResultCount,
  onChange,
}) => {
  const controller = useInputValue({
    value,
    defaultValue: null,
    onChange,
    isReadOnly,
  });

  const { value: defaultValue } = item?.additionInfo ?? { value: "" };

  if (isDraggable) {
    return (
      <FieldPreviewWrapper
        title={item.name}
        index={index}
        prevItemResultCount={prevItemResultCount}
        allItemResultCount={allItemResultCount}
        data-type={item.dataType}
      >
        <DroppableBox
          flex={1}
          name={item.name}
          icon={<TyphographyIcon w="3rem" h="3rem" />}
          id={item.id}
          source={SOURCE.INSPECTION_FORM}
        >
          <Input
            className="draggable-area"
            isReadOnly={isReadOnly}
            backgroundColor="white"
            height="4rem"
            maxWidth="100%"
            placeholder={defaultValue || "記入済みテキスト"}
          />
        </DroppableBox>
      </FieldPreviewWrapper>
    );
  }

  return (
    <FieldPreviewWrapper
      index={index}
      prevItemResultCount={prevItemResultCount}
      allItemResultCount={allItemResultCount}
      title={item.name}
    >
      <Box position={"relative"}>
        <Input
          isReadOnly={isReadOnly}
          backgroundColor="white"
          height="4rem"
          maxWidth="100%"
          width="100%"
          placeholder="記入済みテキスト"
          fontSize={"1.6rem"}
          color={"#171717"}
          _readOnly={{
            cursor: "pointer",
          }}
          border="1px solid #D4D4D4"
          {...controller}
          value={controller.value ?? defaultValue}
          onChange={(e) => controller.onChange(e.target.value)}
          paddingRight={isLoading ? "3rem" : "1rem"}
        />
        {isLoading && (
          <Flex
            justifyContent={"center"}
            alignItems={"center"}
            position={"absolute"}
            right={0}
            top={0}
            w={"3rem"}
            h="100%"
            zIndex={10}
          >
            <Spinner />
          </Flex>
        )}
      </Box>
    </FieldPreviewWrapper>
  );
};

export default memo(PreFilledPreviewer);
